import script from "./Active.vue?vue&type=script&setup=true&lang=js"
export * from "./Active.vue?vue&type=script&setup=true&lang=js"

import "./Active.vue?vue&type=style&index=0&id=3a85ca78&lang=scss&scoped=true"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a85ca78"]])

export default __exports__